(ns dashboard.components.answer
  (:require [clojure.string :as str]))

(def yes-class
  "is-success")

(def no-class
  "is-danger")

(def warning-class
  "is-warning")

(defn response-tag-class
  "Get the CSS class to use with :span.tag markup for highlighting a short response"
  [response]
  (when-let [response (some-> response str/lower-case str/trim)]
    (case response
      "yes" yes-class
      "no" no-class
      "n/a" warning-class
      nil)))
